<template>
  <div>
    <VueDatePicker
      v-model="date"
      :placeholder="$t('enter_the_date')"
      auto-apply
      :teleport="true"
      :enable-time-picker="false"
      :month-change-on-scroll="false"
      :min-date="new Date()"
      :day-names="['S', 'M', 'T', 'W', 'T', 'F', 'S']"
      format="MMMM dd yyyy"
      position="right"
      :offset="-1"
      hide-input-icon
      menu-class-name="!px-[17px] !py-[11px] !rounded-none !border-0  shadow-event-content"
      calendar-cell-class-name="!rounded-full text-[10px] font-normal text-charcoal leading-[14px] tracking-[-0.1px] !w-[20px] !h-[20px] !p-[10px]"
      :day-class="getTodayClass"
      required
      week-start="0"
      :range="range"
      :multi-dates="multiDates"
      :week-picker="weekPicker"
      @update:model-value="handleDate"
    >
      <template #trigger>
        <GenericInput
          v-model="getDate"
          input-classes="pr-[40px]"
          :class="triggerClasses"
          :legend-text="false"
          :small-size="triggerSmallSize"
          :text="text || $t('enter_the_date')"
          icon="calendar"
        />
      </template>
      <template #month-year="{ month, year, handleMonthYearChange }">
        <div class="w-full flex item-center justify-between px-[4px]">
          <div
            class="custom-month-year-component text-[11px] font-normal leading-[18px] tracking-[-0.11px]"
          >
            {{ moment().month(month).format('MMMM') }}
            {{ year }}
          </div>
          <div class="flex items-center justify-center gap-x-[5px]">
            <span class="cursor-pointer" @click="handleMonthYearChange(false)">
              <InlineSvg src="/assets/svg/icons/prev.svg" />
            </span>
            <span class="cursor-pointer" @click="handleMonthYearChange(true)">
              <InlineSvg src="/assets/svg/icons/next.svg" />
            </span>
          </div>
        </div>
      </template>
    </VueDatePicker>
    <span
      v-for="err in errors"
      :key="err.$uid"
      class="text-red-alert block mt-[5px] text-[13px]"
    >
      {{ err.$message }}
    </span>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue';

const emit = defineEmits(['update:modelValue']);
const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: '',
  },
  errors: {
    type: Array,
    default: () => [],
  },
  type: {
    type: String,
    default: 'text',
  },
  range: {
    type: Boolean,
    default: false,
  },
  weekPicker: {
    type: Boolean,
    default: false,
  },
  multiDates: {
    type: Boolean,
    default: false,
  },
  triggerSmallSize: {
    type: Boolean,
    default: false,
  },
  triggerClasses: {
    type: String,
    default: '',
  },
  text: {
    type: String,
    default: '',
  },
  legendText: {
    type: Boolean,
    default: true,
  },
  icon: {
    type: String,
    default: '',
  },
  iconClasses: {
    type: String,
    default: '',
  },
  inputFormat: {
    type: String,
    default: 'dddd MMMM DD yyyy',
  },
});

watch(
  () => props.modelValue,
  (newVal) => {
    date.value = newVal;
  }
);
const date = ref(props.modelValue);

import moment from 'moment';

const getTodayClass = (d) => {
  const today = moment(new Date()).format('DD/MM/YYYY');
  const comingDay = moment(d).format('DD/MM/YYYY');
  const selectedDate = moment(date.value).format('DD/MM/YYYY');

  if (comingDay == selectedDate) return '!bg-blue';
  if (comingDay == today) return '!border-grey-pale';

  return '';
};

const getDate = computed(() => {
  if (!date.value) return '';

  if (props.range) {
    return `${moment(date.value[0]).format(props.inputFormat)}, ${moment(
      date.value[1]
    ).format(props.inputFormat)}`;
  }

  return moment(date.value).format(props.inputFormat);
});

const handleDate = () => {
  if (props.range) return emit('update:modelValue', date.value);

  emit('update:modelValue', moment(date.value).format('YYYY-MM-DD'));
};
</script>
